import React, { useEffect, useState } from 'react';
import '../../../../scss/pages/Home/WeeklyContest/leaderBoardHistory.scss'
import LeftArrow from '../../../../asset/svg/leftArrow.svg';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import RightArrow from '../../../../asset/svg/rightArrow.svg';
import DownArrow from '../../../../asset/svg/downArrow.svg';
import coinsWon from '../../../../asset/svg/coinsWon.svg'
import { HOME_PATH, WEEKLY_CONTEST } from '../../../../utils/Constants';
import { useLocation, useNavigate } from "react-router-dom";
import MonthPicker from '../../../../components/common/MonthPicker';
import { LEADERBOARD_HISTORY_DATA } from '../../../../sagas/type';
import { getLocalStoreString } from '../../../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';

var today = new Date();
var currentYear = today.getFullYear();
var currentMonth = today.getMonth()
const currentMonthYear = currentYear + '-' + currentMonth;

function leaderBoardHistory() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { leaderboardHistoryData, } = useSelector(mapStateToProps);
    const [selectedMonthYear, setSelectedMonthYear] = useState(currentMonthYear);

    useEffect(() => {
        leaderBoardHistory();
    }, [selectedMonthYear]);

    const leaderBoardHistory = () => {
        const EmployeeCode = getLocalStoreString("EmployeeCode");
        const contestScoreboardId = location.state?.id;
        const selectedMonthYears = selectedMonthYear;
        const selectedYear = selectedMonthYears.split('-')[0];
        const selectedMonth = selectedMonthYear.split('-')[1];
        dispatch({
            type: LEADERBOARD_HISTORY_DATA,
            payload: { contestScoreboardId, EmployeeCode, selectedYear, selectedMonth },
        });
    }

    const leaderBoardColumnData = [
        { field: 'date', label: 'Date' },
        { field: 'rank', label: 'Rank' },
        { field: 'scores', label: 'Scores' },
        { field: 'coinsEarned', label: 'Coins Earned' },

    ]

    const handleBack = () => {
        navigate(WEEKLY_CONTEST)
    }

    return (
        <div className='leaderBoard-history-container'>
            <div className='leaderBoard-history-container_header'>
                <img className='leaderBoard-history-container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                <span className='leaderBoard-history-container_header_content'>Weekly Contest</span>
            </div>

            <div className='leaderBoard-history-container_table1'>
                <div className='leaderBoard-history-container_table1_heading'>
                    <div className='leaderBoard-history-container_table1_heading_title'>
                        <Typography className='leaderBoard-history-container_table1_heading_title_title1'>Contest History</Typography>&nbsp;&nbsp;
                    </div>
                    <div style={{ color: 'white', paddingRight: '3rem' }}>
                        <MonthPicker onChange={(monthYear) => setSelectedMonthYear(monthYear)} />
                        {/* <span><img style={{ width: '11px', position: 'relative', bottom: '1.5rem', left: '6.2rem' }} src={downArrow} alt='' /></span> */}
                    </div>
                </div>
                <div className='leaderBoard-history-container_table1_tabledata'>
                    <TableContainer component={Paper}>
                        <Table aria-label="caption table">
                            <TableHead >
                                <TableRow >
                                    {leaderBoardColumnData && leaderBoardColumnData.length > 0 && leaderBoardColumnData.map((head) => (
                                        <TableCell sx={{ color: 'gray', textAlign: 'center' }}>{head.label}</TableCell>))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {leaderboardHistoryData && leaderboardHistoryData.entities && leaderboardHistoryData.entities.length > 0 && leaderboardHistoryData.entities.map((row) => (
                                    <TableRow key={row.employeeCode}>
                                        <TableCell sx={{ color: 'gray', textAlign: 'center' }}>
                                            {row.startDate}
                                        </TableCell>
                                        <TableCell sx={{ color: 'white', textAlign: 'center' }}>{row.rank}</TableCell>
                                        <TableCell sx={{ color: 'gray', textAlign: 'center' }}>{row.score}</TableCell>
                                        <TableCell sx={{ color: 'white', textAlign: 'center' }}><div style={{ display: "flex", textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}><img src={coinsWon} className='' alt='' />&nbsp;&nbsp;{row.reward}</div></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        leaderboardHistoryData: state.dashboardConfig.leaderBoardHistorydata,
    }
}

export default leaderBoardHistory